/** 全站品牌 Logo */
export default require("../assets/logoBest.png");
